export default __webpack_public_path__ + "static/media/client2.cc285074.svg";